import { render } from "./JobDetailView.vue?vue&type=template&id=2fa817d2"
import script from "./JobDetailView.vue?vue&type=script&lang=js"
export * from "./JobDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__